import { useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

const useGetPageWidth = (querySelector = '#TermsModal') => {
  const theme = useTheme();
  const breakpoints = theme.breakpoints.values;

  const [pageWidth, setPageWidth] = useState<number>(0);

  const getModalWidth = useCallback(() => {
    const modalContainer = document.querySelector(querySelector);
    const viewportWidth = window.innerWidth;
    const width =
      (modalContainer?.clientWidth || 0) > viewportWidth
        ? viewportWidth
        : modalContainer?.clientWidth;
    setPageWidth(width || breakpoints.sm);
  }, [breakpoints.sm, querySelector]);

  useEffect(() => {
    window.addEventListener('resize', getModalWidth, false);
    getModalWidth();
    return () => {
      window.removeEventListener('resize', getModalWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { pageWidth, getModalWidth };
};

export default useGetPageWidth;
